
import ProjectDisplay from '../components/ProjectDisplay.js';

function ViolationCrawler() {
  const projectData = {
    name: 'Violation Screener',
    tagline: 'Code Violation Intake Assistant.',
    status: 'In Progress',
    version: 'v0.6.9',
    tech: ['React', 'Node.js', 'Express', 'Python', 'Ollama', 'PyTorch'],
    overview:
      'An Agentic LLM that can screen users who have received city code violations. The agent can collect information from the user, such as case numbers, addresses, court orders, and job site descriptions. A professional can then review the case without wasting time collecting all the information themselves.',
    features: [
      'Agentic Capabilities',
      'Custom AI toolkit',
      'Dashboard/Chat interface',
    ],
    links: {
      live: '[Private]',
      github: '[Private]',
    },
  };

  return <ProjectDisplay projectData={projectData} />;
}

export default ViolationCrawler